import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import UserService from '../services/UserService';

const SettingsSideBar = () => {
    const location = useLocation();
    const apiFunction = new UserService();
    const [loginUserRole, setLoginUserRole] = useState("");
    const [email] = useState(localStorage.getItem("Email"));
    const clientID = Number(localStorage.getItem("ClientID"));
    const ApiBaseURL_url = process.env.REACT_APP_URL;
    const AccessToken = localStorage.getItem("AccessToken");

    // Memoize the API call function to prevent unnecessary re-creations
    const fetchUserDetails = useCallback(async () => {
        try {           
            const response = await apiFunction.getProfile(email);
            if (response && (response.status === 200 || response.ok)) {
                const result = response.data || (await response.json());
                setLoginUserRole(result.role || result.userType || "Member");
                //set UserType in the local storage
                localStorage.setItem("UserType", result.role || result.userType || "Member");
                if (result.totalMembers !== undefined) {
                    localStorage.setItem("Totalmembers", result.totalMembers);
                }
            } else {
                console.error('Failed to fetch user details');
            }
        } catch (error) {
            console.error("API call failed:", error);
        }
    }, [email, clientID, ApiBaseURL_url, AccessToken]);

    // Only fetch user details if the role is not already set
    useEffect(() => {
        if (!loginUserRole) {
            fetchUserDetails();
        }
    }, [loginUserRole, fetchUserDetails]);

    return (
        <div className="setting-left">
            <div className="setting-nav">
                <ul className="sideways">
                    <li className={location.pathname === "/settings/profile-setting" ? "active" : ""}>
                        <Link to="/settings/profile-setting">
                            <img alt="" src="/images/setting/user-pen.svg" width="" />
                            Profile Settings
                        </Link>
                    </li>

                    {/* <li className={location.pathname === "/settings/notification" ? "active" : ""}>
                        <Link to="/settings/notification">
                            <img alt="" src="/images/setting/bell.svg" width="" />
                            Notifications
                        </Link>
                    </li> */}
                    <li className={location.pathname === "/settings/reminders" ? "active" : ""}>
                        <Link to="/settings/reminders">
                            <img alt="" src="/images/setting/bell-icon.svg" width="" />
                            Notifications
                             {/* & Reminders */}
                        </Link>
                    </li>
                    {/* <li className={location.pathname === "/settings/integrations" ? "active" : ""}>
                        <Link to="/settings/integrations" >
                            <img alt="" src="/images/icons-v2/settings-sliders2.svg" className="menu-icon" style={{ width: "27px" }} />
                            Integrations
                        </Link>
                    </li> */}
                    <li className={location.pathname.includes("/settings/integrations") ? "active" : ""}>
                        <Link to="/settings/integrations">
                            <img alt="" src="/images/setting/integrations.svg" width="" />
                            Integrations
                        </Link>
                    </li>

                </ul>
            </div>
        </div>
    );
};

export default React.memo(SettingsSideBar);
